import { useState, useEffect } from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { SOURCE_LANGS, DOMAINS } from "../utils/Constant"





export default function QuickDictionaryLookup({
  initialWord = '',
  sourceLang: initialSource = 'eng',
  targetLang: initialTarget = 'hin',
}) {
  const [word, setWord] = useState(initialWord);
  const [sourceLang, setSourceLang] = useState(initialSource);
  const [targetLang, setTargetLang] = useState(initialTarget);
  const [domain, setDomain] = useState('general'); // default: general
  const [result, setResult] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (initialWord) {
      setWord(initialWord);
      handleQuickSearch(initialWord);
    }
    // eslint-disable-next-line
  }, [initialWord]);


  const handleQuickSearch = async () => {
    if (!word?.trim()) return;
    setResult([])
    setLoading(true);
    setResult(null);

    const lang_pair = `${sourceLang}_${targetLang}`

    try {
      const formData = new URLSearchParams();
      formData.append('user', 'sirfzahid007@gmail.com');
      formData.append('lang_pair', lang_pair);
      formData.append('custom_dict_list', 'system,rbiproject,user');
      formData.append('inputString', word.trim());
      formData.append('domain', domain);

      const response = await fetch('https://transzaar.ebslab.com/PostEditTool-Singleton-0.2.5.7/SearchRecordInParallelMTDicts', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (!response.ok) {
        throw new Error(`API failed: ${response.status}`);
      }

      const data = await response.json();

      setResult(data);   // store API response

    } catch (err) {
      console.error('Dictionary search error:', err);
      setResult({ error: 'Failed to fetch data.' });
    } finally {
      setLoading(false);
    }
  };


  // Helper function
  function getCategory(sourceWithCat) {
    if (!sourceWithCat || !sourceWithCat.includes('____')) return '';
    const categoryPart = sourceWithCat.split('____')[1]?.trim();
    if (!categoryPart || categoryPart === 'UNDEFINED') return '';
    return `(${categoryPart})`;
  }

  return (
    <div className="space-y-3 text-sm min-h-[250px] overflow-y-auto">
      {/* Controls row */}
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-2">
        <input
          value={word}
          onChange={(e) => setWord(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleQuickSearch()}
          className="px-3 py-1.5 border rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
          placeholder="Word / phrase"
        />

        <select
          value={sourceLang}
          onChange={(e) => setSourceLang(e.target.value)}
          className="px-3 py-1.5 border rounded bg-white focus:outline-none focus:ring-1 focus:ring-blue-500"
        >
          {SOURCE_LANGS.map((lang) => (
            <option key={lang.value} value={lang.value}>
              {lang.label}
            </option>
          ))}
        </select>

        <select
          value={targetLang}
          onChange={(e) => setTargetLang(e.target.value)}
          className="px-3 py-1.5 border rounded bg-white focus:outline-none focus:ring-1 focus:ring-blue-500"
        >
          {SOURCE_LANGS.map((lang) => (
            <option key={lang.value} value={lang.value}>
              {lang.label}
            </option>
          ))}
        </select>

        <div className="flex gap-2">
          <select
            value={domain}
            onChange={(e) => setDomain(e.target.value)}
            className="flex-1 px-3 py-1.5 border rounded bg-white focus:outline-none focus:ring-1 focus:ring-blue-500"
          >
            {DOMAINS.map((d) => (
              <option key={d.value} value={d.value}>
                {d.label}
              </option>
            ))}
          </select>

          <button
            onClick={handleQuickSearch}
            disabled={loading || !word.trim()}
            className="
              px-4 py-1.5 
              bg-blue-600 text-white 
              rounded hover:bg-blue-700 
              disabled:opacity-50 disabled:cursor-not-allowed
              whitespace-nowrap
            "
          >
            {loading ? '...' : 'Lookup'}
          </button>
          <div className="block">
            <Link to="/dictionary" target="_blank" className="text-blue-600 hover:text-blue-300">
              <FaExternalLinkAlt />
              {/* <span>open new tab</span> */}
            </Link>
          </div>
        </div>
      </div>

      {/* Results Section */}
      <div className="mt-1">
        {/* 1. Loading state – shown ONLY while fetching */}
        {loading && (
          <div className="mt-1 text-center">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600 mx-auto"></div>
            <p className="mt-4 text-gray-600 font-medium">Searching translations...</p>
            <p className="mt-1 text-sm text-gray-500">This usually takes just a few seconds</p>
          </div>
        )}

        {/* 2. Error state – shown ONLY if there's an error AND not loading */}
        {!loading && result?.error && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md">
            <p className="font-medium">Error: {result.error}</p>
            <p className="mt-1 text-sm">Please try again or check your connection.</p>
          </div>
        )}

        {/* 3. Success states – only shown when !loading and no error */}
        {!loading && !result?.error && (
          <>
            {result?.records && result.records.length > 0 ? (
              // Has results → show table
              <div className="overflow-x-auto overflow-y-auto min-h-[250px] border border-gray-200 rounded-md">
                <table className="min-w-full text-sm divide-y divide-gray-200">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border px-4 py-3 text-left font-semibold w-[220px]">
                        Source (Category)
                      </th>
                      <th className="border px-4 py-3 text-left font-semibold">
                        Translations
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {result.records.map((record, index) => (
                      <tr key={index} className="hover:bg-gray-50 transition-colors">
                        <td className="border px-4 py-3 font-medium text-gray-900">
                          {record.source || '—'} {getCategory(record.sourceWithCat)}
                        </td>
                        <td className="border px-4 py-3 text-gray-700">
                          {record.target?.join(', ').replaceAll('_', ' ') || '—'}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              // No results after finished loading
              <div className="min-h-[300px] flex flex-col items-center text-gray-500">
                <svg
                  className="w-14 h-14 mb-5 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <p className="text-xl font-medium text-gray-600">No translations found</p>
                <p className="mt-3 text-base text-gray-500 max-w-md text-center">
                  Try a different word, check spelling, or use fewer filters.
                </p>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}
